<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("PurchaseTaskSetting.import.title") }}
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              @click="
                dialog = false;
                $emit('close');
              "
            >
              fa-times
            </v-icon>
          </template>
          {{ $t("$vuetify.close") }}
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-data-table
        :headers="Headers"
        :items="items"
        multi-sort
        disable-pagination
        hide-default-footer
        class="elevation-0 px-6 pb-2"
      >
        <template v-slot:item.error_msg="{ item }">
          <span class="red--text">{{ item.error_msg }}</span>
        </template>
      </v-data-table>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="secondary"
          outlined
          @click="
            $emit('close');
            dialog = false;
          "
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import i18n from "@/i18n";

export default {
  name: "ImportTasksResult",

  props: {
    value: Boolean,
    items: Array,
  },

  data: () => ({
    dialog: false,
  }),

  computed:{
    Headers() {
      return [
        {
          text: i18n.t("PurchaseTaskSetting.purchase_tasks.tasks"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "user_task_name",
        },
        {
          text: i18n.t("PurchaseTaskSetting.purchase_tasks.staff_name"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "account_name",
        },
        {
          text: i18n.t("PurchaseTaskSetting.purchase_tasks.material_code"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "material_code",
        },
        {
          text: i18n.t("PurchaseTaskSetting.purchase_tasks.material_name"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "material_name",
        },
        {
          text: i18n.t("PurchaseTaskSetting.purchase_tasks.error_msg"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "error_msg",
        },
      ];
    },
  },

  watch: {
    value: {
      immediate: true,
      handler() {
        this.dialog = this.value;
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
        if (!this.dialog) this.$emit("close");
      },
    },
  },
};
</script>